import axios from 'axios'

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getPolls(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        createPoll(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls",
                    data: obj,
                    method: "POST"
                }).then(response => {
                    if (response.status) {
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    console.log("Mal")
                    reject(error)
                })
            });
        },
        //
        PollUpdate(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + obj.id,
                    data: obj,
                    method: "PUT"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        deletePoll(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/polls/' + id,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        getPollFull(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/polls/' + id + '/full',
                    method: 'GET'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        update(o, obj) {
            var params = {
                title: obj.title
                
            };
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + obj.id + "/title",
                    params: params,
                    method: "PUT"
                }).then(response => {
                    if (response.data.status) {
                        console.log(obj);
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        getPollStudents(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + obj.id + "/results",
                    method: "GET",
                    params: obj.params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getDataFile(o, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + params.id + "/students/" + params.idStudent + "/results",
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        getAllData(o, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + id + "/resultsAll",
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },

        getResultStatus(o, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + id + "/hasAnyResult",
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        copyPoll(o, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + id + "/clone",
                    method: "POST"
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        getCPoll(o, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/collaborators/polls/" + id,
                    method: "GET"
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        postColPoll(o, poll) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/collaborators/polls/",
                    method: "POST",
                    data: poll,
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        getVisitPoll(o, id) {
            console.log("visit poll **",)
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/poll/" + id,
                    method: "GET"
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        postVisitPoll(o, poll) {
            console.log("post visit poll **", poll);

            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + `/visits/poll/${poll.id}`,
                    method: "PUT",
                    data: poll.data,
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response);
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        getAllResults({
            rootGetters
        }, obj) {
            const querystring = require('querystring')
            const paramss = querystring.stringify(obj.params)
            return new Promise((resolve, reject) => {
              axios({
                url: process.env.VUE_APP_URL + "/polls/"+ obj.idPoll +"/detailedResults/?"+paramss,
                method: "GET",
              }).then(response => {
                resolve(response);
              }).catch(error => {
                reject(error);
              })
            });
        },
        
        getAllResultByStd({
            rootGetters
        }, obj) {
            const querystring = require('querystring')
            const paramss = querystring.stringify(obj.params)
            return new Promise((resolve, reject) => {
              axios({
                url: process.env.VUE_APP_URL + "/polls/"+ obj.idPoll +"/detailedResults/"+ obj.idStd +"?"+paramss,
                method: "GET",
              }).then(response => {
                resolve(response);
              }).catch(error => {
                reject(error);
              })
            });
        },
        //Detener encuesta
        StopPoll(o,id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + id + "/disable",
                    method: "PUT"
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        //Continuar encuesta
        ResumenPoll(o, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/polls/" + id + "/resume",
                    method: "PUT"
                }).then(response => {
                    if (response) {
                        resolve(response);
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            });
        },
        externalPoll(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/externPoll/pending",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        externalPollAnswer(obj, id_poll) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/externPoll/answer/" + id_poll,
                    method: "POST",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
}